import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["title", "content"]

  reloadOnClose = false

  connect() {
    this.handleOpen = this.open.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    document.addEventListener("keydown", this.handleKeyDown)
    document.addEventListener("drawer:open", this.handleOpen)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeyDown)
    document.removeEventListener("drawer:open", this.handleOpen)
  }

  async open(event) {
    const url = event.detail.url
    this.reloadOnClose = event.detail.reload === true

    // Mostra il drawer
    this.element.classList.remove("hidden")
    setTimeout(() => {
      this.element.querySelector(".drawer-panel").classList.remove("translate-x-full")
    }, 10)

    // Mostra spinner/caricamento
    this.contentTarget.innerHTML = "<p class='text-gray-500'>Caricamento...</p>"
    this.titleTarget.textContent = ""

    // Fetch dei dettagli
    try {
      const response = await fetch(url)
      if (response.ok) {
        const json = await response.json()
        this.titleTarget.textContent = json.title || ""
        this.contentTarget.innerHTML = json.html || ""
      } else {
        this.titleTarget.textContent = "Errore"
        this.contentTarget.innerHTML = "<p class='text-red-500'>Errore nel caricamento.</p>"
      }
    } catch (error) {
      window.location.reload();
    }
  }

  async submit(event) {
    event.preventDefault()

    const form = event.target
    const url = form.action
    const formData = new FormData(form)

    try {
      const response = await fetch(url, {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" }
      })

      const json = await response.json()

      if (response.ok) {
        window.location.href = json.redirect_url
      } else if (response.status === 422) {
        this.titleTarget.textContent = json.title || "Errore"
        this.contentTarget.innerHTML = json.html
      } else {
        this.titleTarget.textContent = "Errore"
        this.contentTarget.innerHTML = "<p class='text-red-500'>Errore generico.</p>"
      }
    } catch (error) {
      this.titleTarget.textContent = "Errore di rete"
      this.contentTarget.innerHTML = "<p class='text-red-500'>Errore di rete.</p>"
    }
  }

  close() {
    if (this.reloadOnClose) {
      window.location.reload()
      return
    } else {
      const panel = this.element.querySelector(".drawer-panel")
      panel.classList.add("translate-x-full")

      setTimeout(() => {
        this.element.classList.add("hidden")
      }, 300)
    }
  }

  handleKeyDown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
